import { WmEntityState } from '@wm-front/shared/interfaces'

/** Used to transform a Dictionnary in an array to be used in a *ngFor
 * @param { EntityState<T> } state the property of the state to map
 * @return { T[] } The mapped array
 */
export function selectEntities<T>(state: WmEntityState<T>): T[] {
  return (state.ids as number[]).map((id) => state.entities[id])
}
